<template>
  <!--票卷詳情(首頁優惠卷點進來) -->
  <div class="CouponDetail">
    <navigation-bar Close/>
    <div class="main">
      <el-image :src="imgUrl" fit="cover" class="pic"></el-image>
      <div class="container">
        <div>
          <span class="coupon-type" :title="typeName">{{typeName}}</span>
          <div class="float-right">
            剩餘 <span class="red">{{ remaining }}</span> 張
          </div>
        </div>
        <div>
          <h4 class="mt-2">{{ name }}</h4>
          <div class="UseBranch">
            <h6>適用分店</h6>
            <div class="branch-list" @click="$router.push({name: 'UsefulStoreList', query:{type: 'coupon', id: couponId}})">
                <span v-for="(item,index) in storeList "
                      :key="index">
                  {{item.name}}
                </span>
            </div>
            <div class="arrow-btn" @click="$router.push({name: 'UsefulStoreList', query:{type: 'coupon', id: couponId}})"><i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="UseBranch">
            <h6>活動檔期</h6>
            <div class="date">
              {{ activityEnd }} 止
            </div>
          </div>
          <el-divider></el-divider>

          <h6>活動說明</h6>
          <p>{{content}}</p>

          <h6 class="mt-4">注意事項</h6>
          <p v-html="contentPrecautions"></p>
        </div>

      </div>
    </div>
    <div class="text-center footer-button">
      <el-button type="primary" round class="w-50" :disabled="checkTake!==0" @click="callGetCouponApi">{{takeBtn}}</el-button>
    </div>


    <comm-dialog :value="isShowDialog" :outerContent="dialogMsg" :isCancel="false"
                 @result="onDialogResult"></comm-dialog>

    <comm-dialog class="dialog-dark" v-if="!isLogin" :value="!isLogin" :outerContent="'請先登入'" :isModal="false" :pageName="'Login'"  @result="onCommDialogClose"></comm-dialog>
    <join-member-dialog :value="joinDialog.isShowDialog" :outerContent="joinDialog.dialogTitle" :mainContent="joinDialog.dialogMsg" :isModal="false" :isCancel="joinDialog.cancelable" @result="onJoinMemberDialogClose"/>
    <loading
        :active.sync=isLoading
        :can-cancel="false"
        :is-full-page="true">
    </loading>
    <toast/>
  </div>
</template>

<script>
  import Toast from "@/components/Toast.vue";
  import * as mutationTypes from '@/store/mutationTypes';
  import CommDialog from "@/components/CommDialog";
  import JoinMemberDialog from "../../components/JoinMemberDialog";

export default {
  name: 'ActivityCouponDetail',
  components: {
    CommDialog,
    Toast,
    JoinMemberDialog,
  },
  data() {
    return {
      couponId: parseInt(this.$route.query.couponId? this.$route.query.couponId:'0'),
      name: '',
      content: '',
      contentPrecautions: '',
      activityEnd: '',
      convertEnd: '',
      isGift: '',
      imgUrl: '',
      typeName: '',
      storeNameList: [],
      vendorList: [],
      merchantList: [],
      storeList: [] ,
      isLogin : this.$auth.isAdminLogin() ,
      remaining :0,  //剩餘張數
      isLoading :false ,
      isShowDialog: false,
      dialogMsg: '',
      checkTake:0,
      isMember: false,        //是否爲會員
      //dialog 用
      joinDialog: {
        isShowDialog: false,
        dialogTitle: '',
        dialogMsg: '',
        cancelable: false,
      },
    }
  },
  computed:{
    takeBtn:function(){
      return ["我要領取","無法領取","票券已領完","領取時間已結束","-已領取-","優惠券組數用完"][this.checkTake];
    }
  },
  created() {
    if (this.isLogin) {
      this.isLoading = true;
      // this.getCouponInfoById();
      this.callGetCouponInfoByIdApi(0, 0);
    }
  },
  mounted() {

  },
  methods: {
    /** 我要領取  **/
    callGetCouponApi() {
      this.isLoading = true ;
      this.$http.fetchWithAuth`GetCoupon${{
        id: this.couponId
      }}${json => {
        if (json.data !== null && json.data !== '') {
          this.checkTake = Number(json.data.checkTake);
          if (json.status) {
            this.remaining = json.data.residue;
            this.showDialog(json.message);
            this.callGetCouponInfoByIdApi(0, 0);
          } else {
            this.showDialog('抱歉：' + json.message);
          }
        }
        this.isLoading = false ;
      }}}`;
    },
    showDialog(msg) {
      this.dialogMsg = msg;
      this.isShowDialog = true;
    },
    onDialogResult() {
      this.isShowDialog = false;
    },

    /** 取得GPS並取得票卷資訊 */
    getCouponInfoById: function () {
      let self = this;

      let onSuccess = function(position) {
        self.callGetCouponInfoByIdApi(position.coords.longitude, position.coords.latitude);
      };

      let onError = function(error) {
        self.callGetCouponInfoByIdApi(0, 0);
        self.$public.showNotify("code: "+error.code+", message: "+error.message+"。無法定位GPS", false, 3000);
      };

      self.$public.getGpsLocation(onSuccess, onError);
    },

    /** 呼叫 取得票卷資訊 api */
    callGetCouponInfoByIdApi(lng, lat) {
      let self = this;
      self.isLoading = true ;

      self.$http.fetchWithAuth`GetCouponInfoById${{
        id: self.couponId,
        lng: lng ,
        lat: lat ,
      }}${json => {
        self.isLoading = false ;
        if (json.data !== null && json.data !== '') {
          self.couponId = json.data.id ;
          self.name = json.data.name ;
          self.content = json.data.content ;
          self.contentPrecautions = json.data.contentPrecautions;
          self.activityEnd = json.data.activityEnd;
          self.convertEnd = json.data.convertEnd;
          self.imgUrl = json.data.imgUrl;
          self.typeName = json.data.typeName;
          self.data = json.data.data;
          self.storeNameList = json.data.storeNameList;
          self.vendorList = json.data.vendorList;
          self.merchantList = Object.values(json.data.merchantList).flat(2);
          self.checkTake = json.data.checkTake;

          self.storeList = []
          self.storeNameList.forEach( item => {
            self.storeList.push({
              "name": item.name === "" ? item.brandName : item.brandName+"-"+item.name,
            })
          })
          self.merchantList.forEach( item => {
            self.storeList.push({
              "name": item.merchantName === "" ? item.brandName : (item.brandName === "" ? item.merchantName : item.brandName+"-"+item.merchantName),
            })
          })
          self.vendorList.forEach( item => {
            self.storeList.push({
              "name": item.name,
            })
          })

          if (json.data.residue === undefined || json.data.residue === null) {
            self.remaining = 0;
          } else {
            self.remaining = json.data.residue ;
          }

          if (json.data.checkTake === undefined || json.data.checkTake === null) {
            self.checkTake = 1;
          } else {
            self.checkTake = json.data.checkTake;
          }
        }
      }}}`;
    },

    /** 是否加入會員 */
    isJoinMember: function () {
        let self = this;
        //取得店家資訊
        self.isLoading = true;
        self.$http.fetch`IsAddStore${{
            id: self.id,
        }} ${json => {
            self.isMember = json.status;
        }}`;
    },

    /** 加入成爲會員 */
    addMember: function(storeId) {
      let self = this;
      return new Promise(function(resolve, reject) {
        self.$http.fetchWithAuth`AddStore${{
          id: storeId
        }} ${json => {
          self.isMember = json.status;

          if (json.status) {
            //完成
            resolve();
          } else {
            reject('無法加入會員:' + json.message);
          }

        }}`;
      });
    },

    /** 加入會員訊息 dialog */
    showJoinMemberDialog: function (title, msg, cancelable = false) {
      this.joinDialog.cancelable = cancelable;
      this.joinDialog.dialogTitle = title;
      this.joinDialog.dialogMsg = msg;
      this.joinDialog.isShowDialog = true;
    },

    /** JoinMemberDialog 關閉事件 */
    onJoinMemberDialogClose: function(result) {
      this.joinDialog.isShowDialog = false;

      if(result) {
        if (this.id > 0) {
          let self = this;
          self.isLoading = true;
          //加入會員
          self.addMember(self.id)
                  .then( () => {
                    self.isLoading = false;
                    //加入成功
                    self.showDialomutationTypesg(`加入會員成功`);
                  })
                  .catch( (error) => {
                    self.isLoading = false;
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                  });
        }
      }
    },

    /** dialog 關閉事件 */
    onCommDialogClose(result) {
      if (result) {
        this.$router.push({name: 'Login'});
      } else {
        this.$router.go(-1)
      }
    },
  }
}

</script>

<style lang="less" scoped src="../../less/gift.less"/>